import { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch } from 'react-redux';
import { getLivePrivacyPolicy } from '../../../store/actions/event/event-actions';
import { useTypedSelector } from '../../../store/reducers/use-typed-selector';
import { cannedPrivacyPolicy } from '../../admin/create/homepage/editor/privacy-policy/cannedPrivacyPolicy';
import '../../admin/create/homepage/editor/privacy-policy/privacy-policy.scss';
import WaitingIndicator from '../../general-ui/waiting-indicator/waiting-indicator';
import './privacy-policy.scss';
import classNames from 'classnames';

const PrivacyPolicy: React.FC = () => {

	const { eventBundle, token, privacyPolicy } = useTypedSelector(state => ({
		eventBundle: state.LiveEventReducer.eventBundle,
		token: state.AuthReducer.token,
		privacyPolicy: state.LiveEventReducer.privacyPolicy,
	}));

	const dispatch = useDispatch();

	useEffect(() => {
		if (eventBundle?.terms_id) {
			dispatch(getLivePrivacyPolicy(eventBundle?.privacy_policy));
		}
	}, [eventBundle, token, dispatch]);

	const textOverrides = privacyPolicy?.settings?.content;

	return (
		<div className="privacy-policy">
			{eventBundle?.privacy_policy ? (
				privacyPolicy ? (
					<ReactMarkdown className={classNames(textOverrides?.color)} source={privacyPolicy.content} />
				) : (<WaitingIndicator />)
			) : (
				<ReactMarkdown source={cannedPrivacyPolicy} />
			)}
		</div>
	);
};

export default PrivacyPolicy;